export const cityKey = 'city';
export const yearsKey = 'years';
export const regionKey = 'region';
export const typeCorporateKey = 'typeCorporate';
export const stateKey = 'state';
export const clearCompanyKey = 'clearCompany';
export const advertsCountKey = 'advertsCount';
export const mainStatsKey = 'mainStats';
export const moderateTextKey = 'common/moderateText';
export const reviewVehicleKey = 'common/getVehicleReview';
export const aiDescriptionKey = 'common/generateAiDescription';
export const vehicleOptionsKey = 'common/getVehicleOptions';
export const fuelPricesKey = 'common/getFuelPrices';
export const translateTextKey = 'common/translateText';
